import { Component, ViewChild } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DealerService, SpinnerService, AuthenticationService } from '../services';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { TopLayoutComponent } from '../layouts/top-layout.component';
import { Dealer, NonCDKDealer } from '../models';
import { Observable } from 'rxjs/Observable';
import { timer } from 'rxjs/observable/timer';
import { identifierModuleUrl } from '@angular/compiler';

@Component({ templateUrl: 'cdk-dealer-mapping.component.html' })
export class CdkDealerMappingComponent {
    pageTitle: any;
    editDealerForm: FormGroup;
    private sub: Subscription;
    DealerCode: any;
    DealerName: any;
    private subscription: Subscription = new Subscription();
    phoneNumbervalidationCheck: boolean = false;
    displayDialogDM: boolean;
    rowData: any;
    naturalKey: any;
    dealerName: any;
    LstDlrMapping: any;
    DealerInfo:any;
    stype: string;
    rowListData: any;

    constructor(
        private dealerService: DealerService,
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private spinnerService: SpinnerService,
        private authenticationService: AuthenticationService,
        private http: HttpClient) { }

    ngOnInit() {
        this.DealerInfo = JSON.parse(localStorage.getItem('DealerInfo'));
        this.spinnerService.start();
        this.displayDialogDM = true;
        this.DealerInfo.ListDealerMapping = [];
        this.rowData = this.DealerInfo;
        this.naturalKey = this.rowData.NaturalKey;
        this.dealerName = this.rowData.DealerName;
        this.dealerService.getDealerMappings(this.DealerInfo.ParentDealerId).pipe(first()).subscribe(dealermappings => {
            this.DealerInfo.ListDealerMapping = dealermappings;
            this.LstDlrMapping = dealermappings;
            this.spinnerService.stop();
        })
             

    }
    getDealerMappings(data) {
        if (this.stype == 'Edit') {
            this.rowListData.ListDealerMapping = [];
            this.dealerService.getDealerMappings(data.ParentDealerId).pipe(first()).subscribe(dealermappings => {
                this.rowListData.ListDealerMapping = dealermappings;
                this.LstDlrMapping = dealermappings;
                this.spinnerService.stop();
            })
        }
        else {
            this.dealerService.getDealerMappings(data.ParentDealerId).pipe(first()).subscribe(dealermappings => {
                data.ListDealerMapping = dealermappings;
                this.LstDlrMapping = dealermappings;
                this.spinnerService.stop();
            })
        }
    }

  
}